export const GET_USER_MANAGEMENT = 'ANNOUNTCEMENT/get_user-_management';
export const GET_SINGLE_USER_MANAGEMENT =
  'ANNOUNTCEMENT/get_single_user_management';
export const UPDATE_USER_MANAGEMENT = 'ANNOUNTCEMENT/update_user-_management';
export const CREATE_USER_MANAGEMENT = 'ANNOUNTCEMENT/create_brangay';
export const REMOVE_USER_MANAGEMENT = 'ANNOUNTCEMENT/remove_user_management';

export const GET_ROLE_LIST = 'ROLE/get_role_list';

export const FORM_DATA = {
  media: '',
  thumbnail: '',
  title: '',
  description: '',
  author: '',
  content: '',
  is_active: '',
  is_video: '',
  date_posted: '',
  post_type: '',
  is_featured: '',
};

export const TAGS = [
  { label: 'BREAKING', value: 'BREAKING' },
  { label: 'HEALTH AND WELLNESS', value: 'HEALTH AND WELLNESS' },
  { label: 'COVID UPDATES', value: 'COVID UPDATES' },
  { label: 'CITY GOVERNANCE', value: 'CITY GOVERNANCE' },
  { label: 'UPDATES', value: 'UPDATES' },
];
